import { Vector2 } from './types';

class Trail {
  positions: Vector2[] = [];
  maxLength: number = 10;
  color: string;
  width: number;

  constructor(color: string = '#ffff00', width: number = 2) {
    this.color = color;
    this.width = width;
  }

  addPosition(x: number, y: number): void {
    this.positions.push({ x, y });
    if (this.positions.length > this.maxLength) {
      this.positions.shift();
    }
  }

  update(): void {
    if (this.positions.length > 0 && Math.random() > 0.3) {
      this.positions.shift();
    }
  }

  render(ctx: CanvasRenderingContext2D): void {
    if (this.positions.length < 2) return;

    ctx.save();
    ctx.strokeStyle = this.color;
    ctx.lineCap = 'round';
    
    for (let i = 1; i < this.positions.length; i++) {
      const alpha = i / this.positions.length;
      ctx.globalAlpha = alpha * 0.6;
      ctx.lineWidth = this.width * (i / this.positions.length);
      
      ctx.beginPath();
      ctx.moveTo(this.positions[i - 1].x, this.positions[i - 1].y);
      ctx.lineTo(this.positions[i].x, this.positions[i].y);
      ctx.stroke();
    }
    
    ctx.restore();
  }

  clear(): void {
    this.positions = [];
  }
}

export class TrailManager {
  private trails: Map<string, Trail> = new Map();

  addTrail(id: string, x: number, y: number, color: string = '#ffff00', width: number = 2): void {
    if (!this.trails.has(id)) {
      this.trails.set(id, new Trail(color, width));
    }
    this.trails.get(id)!.addPosition(x, y);
  }

  update(): void {
    this.trails.forEach(trail => trail.update());
  }

  render(ctx: CanvasRenderingContext2D): void {
    this.trails.forEach(trail => trail.render(ctx));
  }

  removeTrail(id: string): void {
    this.trails.delete(id);
  }

  clear(): void {
    this.trails.clear();
  }
}